import {Component} from '../../core';
import constants from '../../cityConstant.js';
import {isSet,seoUrl,isEmpty} from '../../utils/common';

/**
 * Coworkhome Categories component
 */
export class CoworkCategoriesComponent extends Component {

    static alias = 'cowork-categoties';

    constructor(el) {
        super(el);
    }

    onComponentLoaded() {
        this.type = 'pbg';
        // Initialize the categories
        this.initializeCategories();
    }

    initializeCategories(){

        this.fetchCategories(8).then((categories) => {
            // Update the state
            this.setState({...this.state, categories});
            
            // Render categories
            this.renderCategories(this.state.categories);
        });
    }

    fetchCategories(size) {
        // Render categories
        return fetch(`/homes/re2/coworkCategories?size=${size}`).then((res) => res.json());
    }

    /**
     * Renders categories
     * @param {Array} categories
     */
    renderCategories(categories = []) {

        this.refs.coworkCategories.innerHTML = categories.reduce((html, response) =>  html + `
           <a onclick="coworkGa('QH_CoWork','Homepage_CoWork_Center-tile', 'QH_CoWork_Homepage_Center-tile_Category-tile_click_${response.unitType}');" href="//www.quikr.com/coworking/coworking-spaces?q=${this.getUnitTypeQuery(response.unitType)}" class="cw_cat_tile">
                <div class="flip_wrapper_front"> 
                    <div class="img_wrapper">
                        ${this.getImageUrl(response)}
                        <div class="cw_strip ${this.getClass()}">${response.unitType.replace("_"," ")}</div>
                    </div>
                </div>
                <div class="flip_wrapper_back">
                    <div class="cw_dark_bg gbg">
                    </div>
                    <div class="cw_cat_hover">
                        <p>${response.description}</p>
                        <h4>Explore Now <svg class="icon-right-arrow arrowrgt" width="10px" height="10px"><use xlink:href="#icon-right-arrow"></use></svg></h4>
                    </div>
                </div>
            </a>`, '');

        if(isEmpty(this.refs.coworkCategories.innerHTML)){
            document.getElementById("categoriesSection").classList.add('hide');
        }
        
    }

    getImageUrl(response) {
        if(response.media && response.media != '' && response.media != 'NULL') {
            let image = response.media.replace("80x80","300x300");
            return `<img src="${image}" />`;
        } else {
            return `<img class="defualt_img" src="${window.CDNURL}/image/QC_DefaultImage.jpg" />`
        }
    }

    getClass(){
        if(this.type == 'gbg'){
            this.type = 'pbg';
        }else if(this.type == 'pbg'){
            this.type = 'gbg';
        }
        return this.type;
    }

    getUnitTypeQuery(unittype)
    {
        let query = '';
        if(unittype != '' && unittype != 'undefined') {
            let filter = {};
            filter.typeofspace = [];
            filter.typeofspace = unittype.toLowerCase().replace("_"," ").replace(/\b\w/g, l => l.toUpperCase());
            query = JSON.stringify(filter);
            query = btoa(query);
            query = encodeURIComponent(query);
        }
        return query;
    }


}